import Hero from '../components/Hero'
import Introduction from '../components/Introduction'
import About from '../components/About'
import Services from '../components/Services'
import Compliance from '../components/Compliance'
import Process from '../components/Process'
import FAQ from '../components/FAQ'
import Contact from '../components/Contact'

const Home = () => {
    return (
        <>
            <Hero />
            <Introduction />
            <About />
            <Services />
            <Compliance />
            <Process />
            <FAQ />
            <Contact />
        </>
    )
}

export default Home
